import React, {createContext, useCallback, useContext, useState} from "react";
import {getTags} from "../../services/Tags.service";
import {useQuery} from "react-query";
import {useUser} from "./app";

function changeArray(item) {
    return item.map(i => ({ value: i.id, label: i.name }))
}

export const TagsContext = createContext(0);

export const TagsProvider = (props) => {

    const [codigo_gri, setCodGri] = useState([]);
    const [dimensao_gri, setDimGri] = useState([]);
    const [codigo_sasb, setCodSasb] = useState([]);
    const [dimensao_sasb, setDimSasb] = useState([]);
    const [setor_sasb, setSetorSasb] = useState([]);
    const [hashtag, setHashtag] = useState([]);
    const [temas_materiais, setTemas] = useState([]);
    const [ods, setOds] = useState([]);
    const [tcfd, setTcfd] = useState([]);
    const [dim_m_c_stakeholder, setStakeholder] = useState([]);
    const [flag_compromissos, setFlagCompromissos] = useState([]);

    const [tagsList, setTagsList] = useState([])

    const [tagListLang, setTagListLang] = useState([])
    const [tagsListEn, setTagListEn] = useState([])


    const [allTags, setAllTags] = useState([])

    const {} = useQuery(['listTags'],
        () => {
            return getTags()
        }, {
            onSuccess: (res) => {

                setAllTags(res)

                res.reduce(function(items, tags) {
                    if (!items[tags.tag_type_code]) {
                        items[tags.tag_type_code] = [];
                    }

                    items[tags.tag_type_code].push({
                        value: tags.id, label: tags.name, labelEn: tags.name_en
                    })

                    setTagsList(items)

                    return items
                },{})
            },
            onError: (err) => {
                console.log('erro tags', err)
            },
            retry: false,
            refetchOnWindowFocus: true,
        })



    const getTagsLang = (lang) => {

       return allTags.reduce(function(items, tags) {
            if (!items[tags.tag_type_code]) {
                items[tags.tag_type_code] = [];
            }

            items[tags.tag_type_code].push({
                value: tags.id, label: lang === 'en-US' && tags.name_en ? tags.name_en : tags.name
            })

            setTagListLang(items)
            setTagsList(items)

            return items
        },{})

    }

    const getTagsEn = () => {

        return allTags.reduce(function(items, tags) {
            if (!items[tags.tag_type_code]) {
                items[tags.tag_type_code] = [];
            }

            items[tags.tag_type_code].push({
                value: tags.id, label: tags.name_en
            })

            setTagListEn(items)
            return items
        },{})

    }

    const includeTags = useCallback((data) => {

        if (data.temas_materiais) {
            setTemas(changeArray(data.temas_materiais))
        }

        if (data.hashtag) {
            setHashtag(changeArray(data.hashtag))
        }

        if (data.ods) {
            setOds(changeArray(data.ods))
        }

        if (data.dimensao_sasb) {
            setDimSasb(changeArray(data.dimensao_sasb))
        }

        if (data.codigo_sasb) {
            setCodSasb(changeArray(data.codigo_sasb))
        }

        if (data.setor_sasb) {
            setSetorSasb(changeArray(data.setor_sasb))
        }

        if (data.dimensao_gri) {
            setDimGri(changeArray(data.dimensao_gri))
        }

        if (data.codigo_gri) {
            setCodGri(changeArray(data.codigo_gri));
        }

        if (data.dim_m_c_stakeholder) {
            setStakeholder(changeArray(data.dim_m_c_stakeholder))
        }

        if (data.tcfd) {
            setTcfd(changeArray(data.tcfd))
        }

        if (data.flag_compromissos) {
            setFlagCompromissos(changeArray(data.flag_compromissos))
        }

    }, []);

    const clearTags = () => {
        setTemas([])
        setHashtag([])
        setOds([])
        setDimSasb([])
        setCodSasb([])
        setSetorSasb([])
        setDimGri([])
        setCodGri([]);
        setStakeholder([])
        setTcfd([])
        setFlagCompromissos([])
    }


    const handleChange = (newValue, actionMeta) => {
        switch (actionMeta.name) {
            case 'codigo_gri':
                setCodGri(newValue)
                return;
            case 'ods':
                setOds(newValue)
                return;
            case 'codigo_sasb':
                setCodSasb(newValue)
                return;
            case 'dimensao_gri':
                setDimGri(newValue)
                return;
            case 'dimensao_sasb':
                setDimSasb(newValue)
                return;
            case 'hashtag':
                setHashtag(newValue)
                return;
            case 'temas_materiais':
                setTemas(newValue)
                return;
            case 'dim_m_c_stakeholder':
                setStakeholder(newValue)
                return;
            case 'tcfd':
                setTcfd(newValue)
                return;
            case 'flag_compromissos':
                setFlagCompromissos(newValue)
                return;
            case 'setor_sasb':
                setSetorSasb(newValue)
                return;
            default:
                return;
        }
    };

    const tags = {
        tagsList,
        tagListLang,
        temas_materiais,
        hashtag,
        ods,
        dimensao_gri,
        codigo_gri,
        dimensao_sasb,
        codigo_sasb,
        setor_sasb,
        dim_m_c_stakeholder,
        tcfd,
        flag_compromissos
    }

    return (
        <TagsContext.Provider value={{
            tags,
            tagsList,
            tagListLang,
            tagsListEn,
            includeTags,
            handleChange,
            clearTags,
            getTagsLang,
            getTagsEn
        }}>
            {props.children}
        </TagsContext.Provider>
    )
}

export const useTags = () => useContext(TagsContext);
